import { storyblokEditable } from "gatsby-source-storyblok"

import ComparisonTableSection from "../../../V2/Layouts/ComparisonTableSection"

import { storyblokLinkToYocoLink } from "@utils/storyblok"
import React from "react"

const StoryblokComparisonTableSection = ({
  blok,
}: Storyblok.BlokProps<Storyblok.ComparisonTableSection>) => {
  const blokHeading = blok.heading?.[0] || ({} as Storyblok.LayoutHeading)

  return (
    <ComparisonTableSection
      sectionId={blok._uid}
      rounded={!blok.isNotRounded} //TODO write migration to make this isRounded prop + set to true for all existing gridSections
      heading={{
        ...blokHeading,
        size: blokHeading?.size || "large",
        callout: blokHeading?.callout?.[0],
      }}
      backgroundColor={blok.backgroundColor}
      tableNumDesktopColumns={blok.tableNumDesktopColumns}
      disclaimerText={blok.disclaimerText}
      buttonBorderColor={blok.ctaBorderColor}
      buttonText={blok.ctaText}
      buttonLink={storyblokLinkToYocoLink(blok.ctaLink)}
      outerContainer={blok.outerContainer}
      trackingEvent={blok.trackingEvent}
      trackingEventKey={blok.trackingEventKey}
      trackingEventValue={blok.trackingEventValue}
      id={blok.id}
      tables={blok.tables}
      // @ts-ignore to have more strict typing compared to Storybloks generic object typing
      {...storyblokEditable(blok)}
    />
  )
}

export default StoryblokComparisonTableSection
